import { Reveal } from "@/components/Reveal";

const steps = [
    {
        n: "01",
        title: "Conversa inicial",
        text: "Eu entendo como seu negócio funciona, seus horários e sua linguagem.",
    },
    {
        n: "02",
        title: "Desenvolvimento personalizado",
        text: "Configuro o agente com a identidade do seu negócio, do zero.",
    },
    {
        n: "03",
        title: "Ativação e acompanhamento",
        text: "O agente entra em operação. Eu monitoro e ajusto.",
    },
];

export const Implementation = () => {
    return (
        <section id="implementacao" className="relative py-24 md:py-32 lg:py-40">
            <div className="absolute inset-0 dg-grid opacity-20" />
            <div className="relative max-w-6xl mx-auto px-6 md:px-12">
                <Reveal>
                    <p className="text-sm md:text-base font-semibold uppercase tracking-widest text-[#94B4FF]">
                        Implementação
                    </p>
                    <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#F5F5F5] max-w-3xl">
                        Pronto em até 10 dias. Sem você precisar fazer nada.
                    </h2>
                </Reveal>

                <div className="mt-14 grid md:grid-cols-3 gap-6 md:gap-8">
                    {steps.map((s, i) => (
                        <Reveal key={s.n} delay={i * 0.12}>
                            <div
                                data-testid={`implementation-step-${i}`}
                                className="group relative h-full overflow-hidden rounded-2xl border border-[#1E1E28] bg-[#121218] p-8 transition-colors hover:border-[#3B6FFF]/40"
                            >
                                <div className="font-display text-7xl font-extrabold leading-none dg-text-stroke select-none">
                                    {s.n}
                                </div>
                                <h3 className="mt-4 font-display text-xl font-semibold text-[#F5F5F5]">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-[#F5F5F5]/60 leading-relaxed">
                                    {s.text}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.2}>
                    <div className="mt-10 rounded-2xl border border-[#1E1E28] bg-[#0E0E13] px-6 py-6 text-center">
                        <p className="text-[#F5F5F5]/80 max-w-2xl mx-auto">
                            Cada implementação é feita de forma personalizada.{" "}
                            <span className="text-[#F5F5F5] font-semibold">
                                Não é um template.
                            </span>{" "}
                            É um agente construído especificamente pro seu negócio.
                        </p>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};

export default Implementation;
